document.addEventListener("turbo:load", () => {
  console.log("Expenses JS loaded via Turbo");

  const addItemBtn = document.getElementById("expense-add-item");
  const itemsTable = document.querySelector("#expense-items-table-body");
  const orderTotalDisplay = document.getElementById("expense-order-total");
  const itemTemplate = document.getElementById("expense-item-template");

  function recalcRowTotal(row) {
    const unitCost = parseFloat(row.querySelector(".expense-unit-cost")?.value) || 0;
    const qty = parseFloat(row.querySelector(".expense-qty")?.value) || 0;
    const rowTotalField = row.querySelector(".expense-row-total");
    const total = unitCost * qty;
    if (rowTotalField) rowTotalField.value = total.toFixed(2);
  }

  function recalcOrderTotal() {
    let sum = 0;
    itemsTable.querySelectorAll(".expense-item-row").forEach(row => {
      const destroyFlag = row.querySelector(".expense-destroy-flag");
      if (!destroyFlag || destroyFlag.value !== "1") {
        const rowTotalField = row.querySelector(".expense-row-total");
        sum += parseFloat(rowTotalField?.value) || 0;
      }
    });
    if (orderTotalDisplay) orderTotalDisplay.textContent = sum.toFixed(2);
  }

  // Add new item row
  if (addItemBtn) {
    addItemBtn.addEventListener("click", () => {
      if (!itemTemplate) return;

      const newRowHtml = itemTemplate.innerHTML;
      const uniqueIndex = new Date().getTime();
      const rowHtml = newRowHtml.replace(/NEW_RECORD/g, uniqueIndex);

      const tempDiv = document.createElement("tbody");
      tempDiv.innerHTML = rowHtml.trim();
      const newRow = tempDiv.firstElementChild;

      newRow.querySelectorAll("input, select").forEach(input => {
        if (input.type === "text" || input.type === "number") input.value = "";
        if (input.classList.contains("expense-destroy-flag")) input.value = "0";
      });

      itemsTable.appendChild(newRow);

      // Trigger category filter immediately for new row
      const categorySelect = newRow.querySelector(".expense-category-select");
      if (categorySelect) {
        categorySelect.dispatchEvent(new Event("change"));
      }
    });
  }

  if (itemsTable) {
    // Remove item row
    itemsTable.addEventListener("click", (e) => {
      const removeLink = e.target.closest(".expense-remove-item");
      if (removeLink) {
        const row = removeLink.closest("tr");
        const destroyFlag = row.querySelector(".expense-destroy-flag");
        if (destroyFlag) {
          destroyFlag.value = "1";
          row.style.display = "none";
        } else {
          row.remove();
        }
        recalcOrderTotal();
      }
    });

    // Recalculate totals
    itemsTable.addEventListener("input", (e) => {
      const row = e.target.closest("tr");
      if (row && (e.target.classList.contains("expense-unit-cost") || e.target.classList.contains("expense-qty"))) {
        recalcRowTotal(row);
        recalcOrderTotal();
      }
    });

    // Filter expense types by category
    itemsTable.addEventListener("change", (e) => {
      if (e.target.classList.contains("expense-category-select")) {
        const row = e.target.closest("tr");
        const typeSelect = row.querySelector(".expense-type-select");
        const selectedCategoryId = e.target.value;

        if (typeSelect) {
          Array.from(typeSelect.options).forEach(opt => {
            const catId = opt.getAttribute("data-category-id");
            if (!selectedCategoryId || !catId || catId === selectedCategoryId) {
              opt.hidden = false;
            } else {
              opt.hidden = true;
            }
          });

          // Reset selection if current type doesn't match
          if (typeSelect.selectedOptions.length > 0) {
            const currentCat = typeSelect.selectedOptions[0].getAttribute("data-category-id");
            if (currentCat !== selectedCategoryId) {
              typeSelect.value = "";
            }
          }
        }
      }

      if (e.target.classList.contains("expense-unit-select")) {
        const row = e.target.closest("tr");
        recalcRowTotal(row);
        recalcOrderTotal();
      }
    });

    // Initialize totals and filter types on page load (for edit)
    itemsTable.querySelectorAll(".expense-item-row").forEach(row => {
      recalcRowTotal(row);
      const categorySelect = row.querySelector(".expense-category-select");
      if (categorySelect) {
        categorySelect.dispatchEvent(new Event("change"));
      }
    });
    recalcOrderTotal();
  }
});
